import { render, staticRenderFns } from "./UploadedFileItem.vue?vue&type=template&id=e76b8986&scoped=true&"
import script from "./UploadedFileItem.vue?vue&type=script&lang=ts&"
export * from "./UploadedFileItem.vue?vue&type=script&lang=ts&"
import style0 from "./UploadedFileItem.vue?vue&type=style&index=0&id=e76b8986&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e76b8986",
  null
  
)

export default component.exports